import React, {Component} from "react";
import Main from "../../components/smart/Main";
import FocusFour from "../../components/smart/FocusFour";
import MainMessage from "../../components/smart/MainMessage";
import Logo from './../Logo.png';

class DentalPage extends Component {
    
    render() {
        return (
                <Main Title=" "
                Description=" ">
                   <FocusFour
                   Link1="/Members"
                   Link2="/Employers"
                   Link3="/Providers"
                   Link4="/Brokers"
                   ></FocusFour>
                   <MainMessage>
                        <div className="Main_Message_Content">
                            <p>
                                Matrix Healthcare offers a premier dental option for employer groups who offer fully-insured and self-funded dental plans to their employees, 
                                and our goal is to provide our clients a more personalized experience, along with competitive pricing, excellent coverage, and simplified administration.
                                We will continue to extend our resources to employers looking for a win-win solution for the employer, employee, and dental provider.
                            </p>
                        </div>
                        <div className="Main_Message_Logo_Box">
                            <img src={Logo} alt="Logo"></img>
                        </div>  
                    </MainMessage>
                </Main>         
        )
    }
}

export default DentalPage;
